<svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_1362_1153)">
        <path
            d="M9.5 19C7.51563 19 5.76938 18.2861 4.26125 16.8584C2.75313 15.4307 1.99938 13.4983 2 11.0611C2 9.52824 2.5625 7.86624 3.6875 6.07516C4.8125 4.28408 6.51563 2.34777 8.79688 0.266242C8.89063 0.185563 9 0.121019 9.125 0.0726115C9.25 0.0242039 9.375 0 9.5 0C9.625 0 9.75 0.0242039 9.875 0.0726115C10 0.121019 10.1094 0.185563 10.2031 0.266242C12.4844 2.34777 14.1875 4.28408 15.3125 6.07516C16.4375 7.86624 17 9.52824 17 11.0611C17 13.4977 16.2459 15.4301 14.7378 16.8584C13.2297 18.2868 11.4837 19.0006 9.5 19ZM9.75781 16.0955C9.94531 16.0794 10.1056 16.0026 10.2388 15.8651C10.3719 15.7276 10.4381 15.5624 10.4375 15.3694C10.4375 15.1435 10.3672 14.9618 10.2266 14.8244C10.0859 14.6869 9.90625 14.6265 9.6875 14.6433C9.04687 14.6917 8.36719 14.51 7.64844 14.0982C6.92969 13.6865 6.47656 12.9403 6.28906 11.8599C6.25781 11.6824 6.17594 11.5372 6.04344 11.4242C5.91094 11.3113 5.75844 11.2548 5.58594 11.2548C5.36719 11.2548 5.1875 11.3397 5.04688 11.5094C4.90625 11.6792 4.85938 11.8767 4.90625 12.1019C5.17188 13.5703 5.79688 14.6191 6.78125 15.2484C7.76563 15.8777 8.75781 16.1601 9.75781 16.0955Z"
            fill="#94A3B8"
        />
        <rect
            x="19.6326"
            width="3"
            height="27.3385"
            transform="rotate(52.3055 19.6326 0)"
            fill="#EF4444"
        />
    </g>
    <defs>
        <clipPath id="clip0_1362_1153">
            <rect width="19" height="19" fill="white" />
        </clipPath>
    </defs>
</svg>
